import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  flexDirection: "row",
  justifyContent: "center",
  gap: { xs: 1, sm: 1.5 },
  direction: "ltr",
  mb: 1,
};

export const digitInput =
  (focused: boolean, hasError: boolean): SxProps<Theme> =>
  (theme) => ({
    width: { xs: 44, sm: 54 },
    height: { xs: 54, sm: 62 },
    textAlign: "center",
    fontSize: { xs: "1.375rem", sm: "1.625rem" },
    fontWeight: 800,
    fontFamily: theme.typography.fontFamily,
    color: "text.primary",
    border: `1.5px solid ${hasError ? theme.palette.error.main : focused ? theme.palette.primary.main : theme.palette.divider}`,
    borderRadius: 1.75,
    outline: "none",
    bgcolor: "background.default",
    transition: "all 0.2s ease",
    boxSizing: "border-box",
    p: 0,
  });
